import { render, staticRenderFns } from "./EcocardioDatiList.vue?vue&type=template&id=163ca268"
import script from "./EcocardioDatiList.vue?vue&type=script&lang=js"
export * from "./EcocardioDatiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports